import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Admin from "@/pages/Admin";
export const Route = createFileRoute("/admin/")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><Admin /></ProtectedRoute>) });
